import React, { useContext } from "react";
import TableRow from "@mui/material/TableRow";
import Status from "../../../../shared/components/Status";
import { OutsourceOrder } from "../../../../data/entities";
import { OUTSOURCE_ORDER_STATUS, ROLE } from "../../../../data/enums";
import { OutsourceOrderFilterType, valueToText } from "../../../../configs/filterTypes";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { formatCurrency } from "../../../../utils/format";
import { formatDateVi } from "../../../../utils/dateUtils";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";

export const getStatusColorTheme = (status: string) => {
    switch (status) {
        case OUTSOURCE_ORDER_STATUS.OPEN:
            return "INFO";
        case OUTSOURCE_ORDER_STATUS.EXPORTING:
            return "PENDING";
        case OUTSOURCE_ORDER_STATUS.PARTIALLY_RETURNED:
            return "PENDING";
        case OUTSOURCE_ORDER_STATUS.COMPLETED:
            return "SUCCESS";
        case OUTSOURCE_ORDER_STATUS.CANCELLED:
            return "FAIL";
        default:
            return "INFO";
    }
};

export const OutsourceOrderRow = ({ item }: { item: OutsourceOrder }) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const isShowPrice = ![ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role);
    const providerName = item.provider_name || "N/A";
    const providerCell = item.provider_id ? (
        <StyledNavLink to={`/providers/${item.provider_id}`}>{providerName}</StyledNavLink>
    ) : (
        providerName
    );

    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLink to={`/outsource-orders/${item.id}`}>{item.name}</StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getStatusColorTheme(item.status)}
                    text={valueToText(OutsourceOrderFilterType, "status", item.status)}
                    width="156px"
                />
            </StyledTableCell>
            <StyledTableCell align="left">{providerCell}</StyledTableCell>
            <StyledTableCell align="left">{formatDateVi(new Date(item.due_date))}</StyledTableCell>
            {
                isShowPrice && (
                    <StyledTableCell align="left">{formatCurrency(item.total_price)}</StyledTableCell>
                )
            }
        </TableRow>
    );
};
